import '../gs-core/common/util/array.prototype';
import { AuthFetch, Organization, PrmService, UserModel } from '../gs-core/common';

import { hydrateOwningUnitOrgs } from '../common/models';

export class OwningUnitService {
  private _timer: any;
  private _parentIdToUnits: { [unitId: number]: Organization[] } = {};

  constructor(private authFetch: AuthFetch, private prmService: PrmService) {
    this._timer = setInterval(
      () => this._parentIdToUnits = {},
      12 * 60 * 60 * 1000
    );

    if (this._timer.unref) {
      this._timer.unref();
    }
  }

  destroy() {
    clearInterval(this._timer);
  }

  async findOwningUnitsUnder(parentUnits: Organization[]): Promise<Organization[]> {
    if (!parentUnits || !parentUnits.length) {
      return [];
    }

    const parentIds = parentUnits
      .filter(unit => !!unit.id)
      .map(unit => (unit.id as number).toString());
    const cachedIds = Object.keys(this._parentIdToUnits);

    if (!parentIds.every(id => cachedIds.includes(id))) {
      const fetchPromises = parentIds
        .map(async id => {
          const subunits = await this.authFetch(`/api/unit/${id}/subunits`) as Organization[];

          const hydratePromises = subunits.map(unit => hydrateOwningUnitOrgs(unit, this.prmService));

          this._parentIdToUnits[id] = await Promise.all(hydratePromises);
        });

      await Promise.all(fetchPromises);
    }

    return parentIds
      .flatMap<Organization>(id => this._parentIdToUnits[id])
      .unique()
      .sort(UserModel.sort);
  }
}



// WEBPACK FOOTER //
// ./src/services/OwningUnitService.ts